var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9987 1.9998V3.33313H2.66536V12.6665H13.332V6.66647H14.6654V13.3331C14.6654 13.7013 14.3669 13.9998 13.9987 13.9998H1.9987C1.63051 13.9998 1.33203 13.7013 1.33203 13.3331V2.66647C1.33203 2.29828 1.63051 1.9998 1.9987 1.9998H5.9987ZM12.6318 3.33313L10.6654 1.36664L11.6082 0.423828L15.168 3.98363C15.3242 4.13983 15.3242 4.3931 15.168 4.54931C15.093 4.62433 14.9912 4.66647 14.8851 4.66647H9.33203C8.59563 4.66647 7.9987 5.26342 7.9987 5.9998V9.9998H6.66536V5.9998C6.66536 4.52704 7.8593 3.33313 9.33203 3.33313H12.6318Z",
    fill: "#0064FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.3c09a8f53f3daf537f7107d1ce9447d7.svg";
export { ForwardRef as ReactComponent };